import { TransactionItem } from 'graphql'
import { formatMoney } from 'views/helpers/utils'

import Box from '@mui/material/Box'
import type { GridColDef } from '@mui/x-data-grid-premium'
import DataGrid from 'views/components/DataGrid'
import { useMemo } from 'react'
import { useFlags } from '@equipmentshare/feature-flags'

export type PartsProps = {
	items: TransactionItem[],
}

function getColumns( showWac: boolean ): GridColDef<TransactionItem>[] {
	const baseColumns: GridColDef<TransactionItem>[] = [
		{
			field: 'providerName',
			headerName: 'Manufacturer',
			flex: 1,
			minWidth: 140,
			valueGetter: ( _value, row ) => row.part?.provider?.name,
		},
		{
			field: 'partClassDescription',
			headerName: 'Item',
			flex: 1.4,
			minWidth: 160,
			valueGetter: ( _value, row ) => row.part?.partClass?.description,
		},
		{
			field: 'partNumber',
			headerName: '#',
			flex: 1,
			minWidth: 120,
			valueGetter: ( _value, row ) => row.part?.partNumber,
		},
		{
			field: 'quantityReceived',
			headerName: 'Qty',
			width: 80,
			align: 'right',
			headerAlign: 'right',
			valueGetter: ( _value, row ) => row.quantityReceived ?? row.quantityOrdered,
		},
	]

	const costColumn: GridColDef<TransactionItem> = showWac
		? {
			field: 'wacSnapshot',
			headerName: 'WAC',
			description: 'Weighted Average Cost',
			width: 130,
			align: 'right',
			headerAlign: 'right',
			valueGetter: ( _value, row ) => (
				row.wacSnapshot ? formatMoney( row.wacSnapshot.weightedAverageCost ) : 'N/A'
			),
		}
		: {
			field: 'costPerItem',
			headerName: 'Cost (per unit)',
			width: 130,
			valueFormatter: ( value: number ) => value.toFixed( 2 ),
		}

	return [ ...baseColumns, costColumn ]
}

export default function Parts( { items }: PartsProps ) {
	const flags = useFlags()
	const columns = useMemo( () => getColumns( flags.enableTswWeightedAverageCost ), [ flags ] )

	return (
		<Box sx={{ width: 680 }}>
			<DataGrid
				columns={columns}
				rows={items}
			/>
		</Box>
	)
}
